import React, { useState } from "react";
import "./modal.css";
import Localize from "../../components/Localize/Localize";

const ExitConfirmationModal = ({ idTask, onClose }) => {    
    const description = "WEBGL_EXIT_POPUP_DESCRIPTION";
    const cancelButtonText = "WEBGL_EXIT_POPUP_BUTTON_STAY";
    const exitButtonText = "WEBGL_EXIT_POPUP_BUTTON_LEAVE";

    const exit = () => {
        window.history.go(-2);
    };

    const cancel = () => {
        onClose();
        var iframe = document.getElementById('game-iframe');
        if (iframe) {
            iframe.focus();
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{Localize.translate(description)}</h2>

                <div className="modal-buttons">
                    <button className="primary" onClick={cancel}>{Localize.translateToUpper(cancelButtonText)}</button>
                    <button className="primary-alternative" onClick={exit}>{Localize.translateToUpper(exitButtonText)}</button>
                </div>
            </div>
        </div>
    );
};

export default ExitConfirmationModal;
